import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import router from './router'
import i18n from './i18n'
import './assets/iconfont/iconfont.css'
import './utils/lazyLoad'
import { initWebp } from './utils/webp'

Vue.use(ElementUI)

// 先检测 WebP 支持，再挂载应用（确保图片加载时已知道是否支持 WebP）
initWebp().then(() => {
	new Vue({
		render: h => h(App),
		router,
		i18n
	}).$mount('#app')
})